import { memoizeFunction, mergeStyles } from '@fluentui/react';
import { IAppTheme } from 'common/theme/AppTheme';

import { notHighContrastSelector } from './Accessibility';

export const scrollbarStyleObject = memoizeFunction((theme: IAppTheme) => ({
  '& ::-webkit-scrollbar': {
    [notHighContrastSelector]: {
      width: '7px',
    },
  },
  '& ::-webkit-scrollbar-thumb': {
    background: theme.appColors?.customScrollbarThumb,
    borderRadius: '7px',
  },
  '& ::-webkit-scrollbar-thumb:hover': {
    background: theme.appColors?.customScrollbarThumbHover,
  },
}));

export const getCustomScrollbarStyles = memoizeFunction((theme: IAppTheme) => mergeStyles(scrollbarStyleObject(theme)));
